<template>
  <div class="rounded-lg relative overflow-hidden xl:h-full xl:min-h-[255px]" :class="{ 'rtl-slide': $i18n.locale !== 'en' }">
    <transition name="slide">
      <div v-if="activeBanner" :key="activeSlideIndex" class="h-full w-full">
        <img :src="activeBanner.desktop" :alt="activeBanner.alt" :class="desktopImageClass">
        <img :src="activeBanner.tablet" :alt="activeBanner.alt" class="lg:hidden md:block hidden w-full h-full">
        <img :src="activeBanner.mobile" :alt="activeBanner.alt" class="md:hidden block w-full h-full">
      </div>
    </transition>

    <div v-if="bannerSlides.length > 1" class="absolute bottom-3 left-0 right-0 z-10 flex justify-center items-center">
      <button v-for="(slide, index) in bannerSlides" :key="index" type="button" class="mx-1 h-2 p-0 border-0 rounded-full bg-white cursor-pointer" :class="index === activeSlideIndex ? 'w-5 opacity-100' : 'w-2 opacity-75'" @click="goToSlide(index)"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValuBanner',
  data () {
    return {
      activeSlideIndex: 0,
      slideInterval: null,
      bannerSlides: [
        {
          alt: 'upper-egypt-slide-1',
          desktop: require('@/assets/images/pages/upper-egypt.webp'),
          tablet: require('@/assets/images/pages/upper-egypt-md.jpeg'),
          mobile: require('@/assets/images/pages/upper-egypt-sm.jpeg')
        },
        {
          alt: 'upper-egypt-slide-2',
          desktop: require('@/assets/images/pages/upper-egypt.webp'),
          tablet: require('@/assets/images/pages/upper-egypt-md.jpeg'),
          mobile: require('@/assets/images/pages/upper-egypt-sm.jpeg')
        },
        {
          alt: 'upper-egypt-slide-3',
          desktop: require('@/assets/images/pages/upper-egypt.webp'),
          tablet: require('@/assets/images/pages/upper-egypt-md.jpeg'),
          mobile: require('@/assets/images/pages/upper-egypt-sm.jpeg')
        }
      ]
    }
  },
  computed: {
    activeBanner () {
      return this.bannerSlides[this.activeSlideIndex]
    },
    desktopImageClass () {
      return `lg:block hidden xl:absolute h-full xl:w-auto w-full ${this.$i18n.locale === 'en' ? 'left-0' : 'right-0'}`
    }
  },
  mounted () {
    this.setAutoSlide()
  },
  beforeDestroy () {
    clearInterval(this.slideInterval)
  },
  methods: {
    setAutoSlide () {
      clearInterval(this.slideInterval)
      this.slideInterval = setInterval(this.showNextSlide, 6000)
    },
    showNextSlide () {
      this.activeSlideIndex = (this.activeSlideIndex + 1) % this.bannerSlides.length
    },
    goToSlide (index) {
      this.activeSlideIndex = index
      this.setAutoSlide()
    }
  }
}
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.45s ease;
}

.slide-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(-100%);
}

.rtl-slide .slide-enter {
  transform: translateX(-100%);
}

.rtl-slide .slide-leave-to {
  transform: translateX(100%);
}
</style>
